// extracted by mini-css-extract-plugin
export default {"active":"DrawerComp_active__EOEEy","navLink":"DrawerComp_navLink__mDeu0"};